<template>
    <div v-show="value" class="common-confirm" :style="{'z-index':zIndex}">
      <template v-if="type==='custom'">
        <div class="confirm-module is-custom" :style="{'width': `${width}`}">
          <slot></slot>
        </div>
      </template>
      <template v-else>
        <div class="confirm-module" :style="{'width': `${width}`}">
          <div v-if="showClose" class="btn-close" @click="closeClick">
            <img class="icon" :src="`${imgUrl}/global/icons/iconCloseWhite.png`" alt="" />
          </div>
          <div v-if="isCustomTitle" class="confirm-module-title"><slot name="title"></slot></div>
          <div v-else class="confirm-module-title">{{title}}</div>
          <div class="confirm-module-content"><slot name="content"></slot></div>
          <template v-if="isButton">
            <div class="confirm-module-btn btn-cancel" @click="cancelClick">{{cancelButtonText}}</div>
            <div class="confirm-module-btn" @click="confirmClick">{{confirmButtonText}}</div>
          </template>
        </div>
      </template>
    </div>
</template>

<script>
export default {
    name: 'CommonConfirm',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '250px'
      },
      zIndex: {
        type: Number,
        default: 10500
      },
      title: {
        type: String,
        default: "温馨提示"
      },
      isButton: {
        type: Boolean,
        default: true
      },
      cancelButtonText: {
        type: String,
        default: "取消"
      },
      confirmButtonText: {
        type: String,
        default: "确定"
      },
      isCustomTitle: {
        type: Boolean,
        default: false
      },
      showClose: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'normal'
      }
    },
    data () {
        return  {
          imgUrl: process.env.VUE_APP_IMG_URL
        }
    },
    methods: {
        confirmClick () {
            this.$emit("confirm", true)
        },
        cancelClick() {
            this.$emit("cancel", false)
        },
        closeClick() {
          this.$emit("close", false)
        }
    }
}
</script>

<style scoped lang="less">
.common-confirm {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10500;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);

  & .confirm-module {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    -moz-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    width: 250px;
    padding-top: 24px;
    background-color: #fff;
    border-radius: 5px;
    overflow: visible;
    &.is-custom {
      padding-top: 0;
    }
  }

  & .confirm-module-title {
    padding-bottom: 15px;
    font-size: 18px;
    line-height: 1;
    color: #FEBC10;
    text-align: center;
  }

  & .confirm-module-content {
    padding: 0 15px 15px;
    font-size: 12px;
    line-height: 18px;
    color: #333;
    word-break: break-all;
  }

  & .confirm-module-btn {
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    text-align: center;
    background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
    background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
    background: -moz-linear-gradient(left, #FEBC10, #FAD961);
    background: -o-linear-gradient(left, #FEBC10, #FAD961);
    background: linear-gradient(to right, #FEBC10, #FAD961);
    border-bottom-right-radius: 5px;
    display: inline-block;
    width: 50%;
  }

  & .confirm-module-btn.btn-cancel {
    background: #F6F7F8;
    border-bottom-left-radius: 5px;
  }
}

.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-color: #4a4a4a;
  & .icon {
    width: 12px;
    height: 12px;
  }
}
</style>
